// Lib
import { classicFormat, percentFormat } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_FULL } from '@/lib/gridElements/size';
import { INSTAGRAM } from '@/lib/socialProfile';

// Components
import AgeGenderChart from '@/components/composite/Charts/composed/AgeGenderChart';

export const ageGenderConfig = {
    title: 'chart.instagram.age_gender',
    margin: {
        right: 20,
        left: -20
    },
    name: {
        age: 'age',
        female: 'female',
        male: 'male',
        percentage_male: 'percentage_male',
        percentage_female: 'percentage_female'
    },
    datePickerDoesNotApply: true,
    id: 'ages_genders_distribution',
    social: INSTAGRAM,
    color: {
        female: 'purple',
        male: 'red'
    },
    valueFormat: {
        ...classicFormat,
        signDisplay: 'never'
    },
    tooltipValueTranslation: 'chart.facebook.age_gender_tooltip_translation',
    pieTooltipTranslation: {
        token: 'chart.facebook.age_gender_tooltip_pie_translation',
        values: ['gender', 'value', 'percentage']
    },
    orientation: 'vertical',
    pieValueFormat: percentFormat,
    tooltip: 'chart.instagram.tooltip_age_gender',
    size: SIZE_FULL,
    type: 'chart',
    element: AgeGenderChart
};
